import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { __ } from "services/Translator";

const SortingDropdown = (props) => {
  // Get initial sorting from localStorage or use "Default" as default
  const getInitialSorting = () => {
    const saved = localStorage.getItem("gameSorting");
    return saved || "Default";
  };

  const [selectedSorting, setSelectedSorting] = useState(getInitialSorting);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const sortingOptions = ["Default", "Most Popular", "Newest First", "A-Z Sorting", "Z-A Sorting"];

  const handleSortingChange = (sortingOption) => {
    setSelectedSorting(sortingOption);
    // Save to localStorage for persistence
    localStorage.setItem("gameSorting", sortingOption);

    // Close the dropdown after selection
    setIsDropdownOpen(false);

    if (props.onSortingChange) {
      props.onSortingChange(sortingOption);
    }
  };

  useEffect(() => {
    // If parent provides a default sorting, use it and save to localStorage
    if (props.defaultSorting && props.defaultSorting !== selectedSorting) {
      setSelectedSorting(props.defaultSorting);
      localStorage.setItem("gameSorting", props.defaultSorting);
    }
  }, [props.defaultSorting]);

  return (
    <>
      <Dropdown className="gameSortingDropdown" show={isDropdownOpen} onToggle={(isOpen) => setIsDropdownOpen(isOpen)}>
        <Dropdown.Toggle className="sortingBtn" variant="success" id="dropdown-sorting">
          {selectedSorting}
        </Dropdown.Toggle>

        <Dropdown.Menu className="sortingLists">
          {sortingOptions.map((option, index) => (
            <div key={index}>
              <label htmlFor={`sorting-${index}`}>
                <input
                  checked={selectedSorting === option}
                  id={`sorting-${index}`}
                  type="radio"
                  name="sorting"
                  onChange={() => handleSortingChange(option)}
                />
                <div className="radioDesign"></div>
                <div className="sortingText">{__(option)}</div>
              </label>
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default SortingDropdown;
